import { Auth } from 'aws-amplify';

export default {
  namespaced: true,
  state: () => ({
    uidsData: null,
    loading: false,
    error: null,
  }),

  mutations: {
    setUidsData(state, data) {
      state.uidsData = data;
    },
    setLoading(state, value) {
      state.loading = value;
    },
    setError(state, error) {
      state.error = error;
    },
  },

  actions: {
    async fetchUids({ commit, state }) {
      // prevent duplicate load
      if (state.uidsData || state.loading) return state.uidsData;

      commit('setLoading', true);
      commit('setError', null);

      try {
        const user = await Auth.currentAuthenticatedUser();
        const session = user.getSignInUserSession();
        const accessToken = session.getAccessToken().getJwtToken();
        const idToken = session.getIdToken().getJwtToken();

        const params = new URLSearchParams({
          start: '-7d',
          stop: 'now()',
          command: 'uid',
        });

        const response = await fetch(
          `http://tc3.dasvideolab.cloud:3000/api/metrics?${params}`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${accessToken}`,
              'X-ID-Token': idToken,
            },
          },
        );

        const json = await response.json();
        commit('setUidsData', json);
        return json;
      } catch (error) {
        console.error('[uidsStore] fetch failed:', error);
        commit('setError', error);
        return null;
      } finally {
        commit('setLoading', false);
      }
    },
  },

  getters: {
    uids: (state) => state.uidsData,
    isUidsLoaded: (state) => !!state.uidsData,
    uidsError: (state) => state.error,
  },
};
